import { useState, useEffect } from 'react';
import { useApp } from './hooks/useApp';
import { SCREENS } from './config/constants';
import { isAuthenticated } from './config/api.config';
import { Toast } from './components/ui';

// Screen imports
import PasswordScreen from './screens/PasswordScreen';
import SplashScreen from './screens/SplashScreen';
import OnboardingScreen from './screens/OnboardingScreen';
import HomeScreen from './screens/HomeScreen';
import QuestionnaireScreen from './screens/QuestionnaireScreen';
import SmartQuestionnaireScreen from './screens/SmartQuestionnaireScreen';
import CameraScreen from './screens/CameraScreen';
import AnalysisScreen from './screens/AnalysisScreen';
import ResultsScreen from './screens/ResultsScreen';
import BaselineScreen from './screens/BaselineScreen';
import CalibrationScreen from './screens/CalibrationScreen';
import HistoryScreen from './screens/HistoryScreen';
import SettingsScreen from './screens/SettingsScreen';
import VerificationScreen from './screens/VerificationScreen';

const screens = {
    [SCREENS.SPLASH]: SplashScreen,
    [SCREENS.ONBOARDING]: OnboardingScreen,
    [SCREENS.HOME]: HomeScreen,
    [SCREENS.QUESTIONNAIRE]: QuestionnaireScreen,
    [SCREENS.SMART_QUESTIONNAIRE]: SmartQuestionnaireScreen,
    [SCREENS.CAMERA]: CameraScreen,
    [SCREENS.ANALYSIS]: AnalysisScreen,
    [SCREENS.RESULTS]: ResultsScreen,
    [SCREENS.VERIFICATION]: VerificationScreen,
    [SCREENS.BASELINE]: BaselineScreen,
    [SCREENS.CALIBRATION]: CalibrationScreen,
    [SCREENS.HISTORY]: HistoryScreen,
    [SCREENS.SETTINGS]: SettingsScreen,
};

function App() {
    const { currentScreen } = useApp();
    const [authenticated, setAuthenticated] = useState(isAuthenticated());

    // Re-check auth on mount
    useEffect(() => {
        setAuthenticated(isAuthenticated());
    }, []);

    // Show password screen if not authenticated
    if (!authenticated) {
        return (
            <PasswordScreen onAuthenticated={() => setAuthenticated(true)} />
        );
    }

    const CurrentScreen = screens[currentScreen] || HomeScreen;
    const { setCurrentScreen } = useApp();

    return (
        <>
            <CurrentScreen />
            <Toast />
        </>
    );
}

export default App;
